import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import { privacyPolicyData } from '../Common/PrivacyPolicyData';
import { useEffect, useState } from 'react';
import FeedbackPopup from '../Common/FeedbackPopup';
import FooterComponent from '../Common/FooterComponent';
import ExtensionNavbar from './ExtensionNavbar';
import { sheetsExtensionPrivacyPolicyData } from '../Common/SheetsExtensionPrivacyPolicyData';
import { sheetsExtensionFaqData } from '../Common/SheetsExtensionFaqData';

function SheetsExtensionFaq(){

    const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);

    const isShowConsole = process.env.NODE_ENV === 'development';

    const location = useLocation();
    isShowConsole && console.log("Current Path:", location.pathname); 

    useEffect(() => {
        document.title = "Convert PDF to Google Sheets in 1 click | Convert PDF Bank Statement to CSV | 1-click PDF to Google Sheets Converter, PDF to CSV converter";
    }, []);
    
    const faqElements = sheetsExtensionFaqData?.map((ele, idx) => {
        return(
            <div className='ppEle faq' key={idx}>
                <div className='ppHeader'>{ele.question}</div>
                <div className='ppContent'>{ele.answer}</div>
            </div>
        )
    });

    return(
        <div className='parentDiv'>
            <div className='mainDiv privacyPolicy'>
                <div className='header'>
                    <ExtensionNavbar />
                </div>
                <div className='contentDiv'>
                    <div className='containerDiv'>
                        <div className='title'>FAQ</div>
                        <div className='contentBox'>
                            <div className='content'>
                                {faqElements}
                            </div>
                        </div>
                    </div>
                </div>
                {showFeedbackPopup && <FeedbackPopup closeFeedbackPopup={() => setShowFeedbackPopup(false)}/>}
            </div>
            <FooterComponent forSheetsExtension={true} setShowFeedbackPopup={setShowFeedbackPopup}/>
        </div>
    )
}

export default SheetsExtensionFaq;